import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import loginImg from '../assets/login-vector.avif';
import '@fortawesome/fontawesome-free/css/all.min.css';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [isAggreed, seIsAggreed] = useState(false);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const user = await login(username, password);
            if (user && user.role) {
                const role = user.role.replace(/^\[|\]$/g, '');
                switch (role) {
                    case 'ROLE_CUSTOMER':
                        Swal.fire({
                            icon: "success",
                            title: "Login successful!",
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 2000,
                            timerProgressBar: true,
                        });
                        navigate('/customer-profile');
                        break;
                    case 'ROLE_USER':
                        navigate('/user-profile');
                        break;
                    default:
                        navigate('/login');
                        break;
                }
            } else {
                navigate('/login');
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Login failed",
                text: error.message || "Failed to login.",
                confirmButtonColor: '#c70000'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className='login_page'>
            <div className="container">
                <div className='row d-flex justify-content-around align-items-center'>

                    <div className='col-md-6 d-md-block d-none'>
                        <img src={loginImg} className='img-fluid' alt='Login' loading="lazy" />
                    </div>

                    <div className='col-md-5'>
                        <div className="card login_panel">
                            <div className="card-body">
                                <h3 className="card-title mb-0 text-md-start text-center">
                                    Sign In
                                </h3>
                                <p className='mb-4 mb-md-4 text-md-start text-center'>Manage your fleet with ease and efficiency.</p>
                                <form onSubmit={isAggreed && handleSubmit}>
                                    <div className="form-group text-left">
                                        {/*<label htmlFor="username" className="form-label">Username</label>*/}
                                        <input
                                            type="text"
                                            id="username"
                                            placeholder="Phone No."
                                            className="form-control"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="form-group mb-4 text-left">
                                        <div className="input-group">
                                            <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            placeholder="Password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            />

                                            <span
                                            className="input-group-text password-toggle"
                                            onClick={() => setShowPassword(!showPassword)}
                                            >
                                            <i
                                                className={`fa-solid ${
                                                showPassword ? "fa-eye-slash" : "fa-eye"
                                                }`}
                                            ></i>
                                            </span>
                                        </div>
                                        </div>

                                    {/* <div className="form-check text-right mb-2 mb-md-4 mt-2 show_pass">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="showPassword"
                                            checked={showPassword}
                                            onChange={(e) => setShowPassword(e.target.checked)}
                                        />
                                        <label className="form-check-label small" htmlFor="showPassword">
                                            Show Password
                                        </label>
                                    </div> */}

                                    <div className="form-check text-left mb-2 mb-md-4 mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="isAgrred"
                                            checked={isAggreed}
                                            onChange={(e) => seIsAggreed(e.target.checked)}
                                        />
                                        <label className="form-check-label small" htmlFor="isAgrred">
                                            Breakdown Inc. will send you an SMS verification code when you request one to authenticate your login. Message and data rates may apply. See our <Link to="/privacypolicy">Privacy Policy</Link> and <Link to="/termsandcondition">Terms and Conditions</Link>.
                                        </label>
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100 btn-theme" disabled={loading || !isAggreed}>
                                        {loading ? (
                                            <span>
                                                <i className="fas fa-spinner fa-spin"></i> Please wait...
                                            </span>
                                        ) : (
                                            <span>
                                                Log In
                                            </span>
                                        )}
                                    </button>

                                    <p className="mt-3 mb-0 text-center small">
                                        Don't have an account? <Link to="/signup">Sign Up</Link>
                                    </p>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default LoginPage;
